import React from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const Navbar = ({ t, className }) => {
  return (
    <nav id="navbar" className={className}>
      <ul>
        <li className="nav-item" title={t('layout.nav.bots.title')}>
          <NavLink to="/bots" exact>
            <div className="ms-2">{t('layout.nav.bots.title')}</div>
          </NavLink>
        </li>

        <li className="nav-item" title={t('layout.nav.marketplace.title')}>
          <a href="https://store.youfy.com.br">
            <div className="ms-2">store</div>
          </a>
        </li>

        {/* <li className="nav-item" title={t('layout.nav.reports.title')}>
          <NavLink to="/reports">
            <div className="ms-2">{t('layout.nav.reports.title')}</div>
          </NavLink>
        </li> */}

        <li className="nav-item" title={t('layout.nav.databases.title')}>
          <NavLink to="/databases">
            <div className="ms-2">{t('layout.nav.databases.title')}</div>
          </NavLink>
        </li>
        <li className="nav-item" title={t('layout.nav.ocr.title')}>
          <NavLink to="/ocr">
            <div className="ms-2">{t('layout.nav.ocr.title')}</div>
          </NavLink>
        </li>
        <li className="nav-item" title={t('layout.nav.templates.title')}>
          <NavLink to="/templates">
            <div className="ms-2">{t('layout.nav.templates.title')}</div>
          </NavLink>
        </li>
        <li className="nav-item" title={t('layout.nav.admin.title')}>
          <NavLink to="/admin">
            <div className="ms-2">{t('layout.nav.admin.title')}</div>
          </NavLink>
        </li>
        <li className="nav-item" title={t('layout.nav.admin.title')}>
          <NavLink to="/help">
            <div className="ms-2">{t('layout.nav.help.title')}</div>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default withTranslation()(Navbar);
